import { ListViewProvider } from '../core/ListViewProvider'
import { QueryRequestProvider } from '../core/QueryRequestProvider'
import { QueryResponseProvider } from '../core/QueryResponseProvider'
import { useFetchCommon } from '../../../../../../_metronic/helpers/crud-helper/useQuery'
import Certificate from './Certificate'
import DatePicker from 'react-datepicker'
import { useEffect, useState } from 'react'
import { useAuth } from '../../../../auth'
import DownloadPDFButton from '../table/columns/DownloadPDFButton'
import { UsersTable } from '../table/UsersTable'
import { roleColumns } from './_columns'
import { StatisticsWidget6 } from '../../../../../../_metronic/partials/widgets'
import { KTCard, stringifyRequestQuery } from '../../../../../../_metronic/helpers'
import { useRef } from 'react'
import Select from 'react-select'


const initialState = {
  facility: '',
  start_date: '',
  end_date: '',
}

const QualityList = () => {
  const [userSelectedData, setUserSelectedData] = useState<any>(initialState)
  const [searchResult, setSearchResult] = useState(false)
  const connectedData =
    new Date(userSelectedData?.date || new Date())?.toLocaleDateString('en-GB') || ''
  const { isFacilityManager, auth }: any = useAuth()




  const certificateRef = useRef<HTMLDivElement>(null)
  const downloadCertificate = () => {
    // Create and add the print CSS
    const printCSS = document.createElement('style');
    printCSS.innerHTML = `
      @media print {
        body * {
          visibility: hidden;
        }
        
        .printable-section,
        .printable-section * {
          visibility: visible;z
        }
        
        .printable-section {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
        }
        
        @page {
          margin: 1cm;
          size: auto;
        }
        
        body {
          margin: 0;
          padding: 0;
        }
      }
    `;
    document.head.appendChild(printCSS);

    // Add the class to your div
    if (certificateRef.current) {
      certificateRef.current.classList.add('printable-section');
    }

    // Print
    window.print();

    // Clean up after printing
    setTimeout(() => {
      document.head.removeChild(printCSS);
      if (certificateRef.current) {
        certificateRef.current.classList.remove('printable-section');
      }
    }, 1000);
  };


  const downloadExcel = () => {
    const transactions = supplierLedgerList?.[0]?.transactions || [];

    if (transactions.length === 0) {
      alert('No data to export');
      return;
    }

    // Define headers based on your column structure
    const headers = [
      { label: 'S.N', value: 'id' },
      { label: 'Date', value: 'date' },
      { label: 'Transaction id', value: 'transactionId' },
      { label: 'Transaction type', value: 'transactionType' },
      { label: 'Quantity', value: 'supplied' },
      { label: 'Amount', value: 'amount' }
    ];

    // Create HTML table
    let htmlTable = '<table border="1"><thead><tr>';

    // Add headers
    headers.forEach(header => {
      htmlTable += `<th>${header.label}</th>`;
    });
    htmlTable += '</tr></thead><tbody>';

    // Add data rows
    transactions.forEach((row, index) => {
      htmlTable += '<tr>';
      headers.forEach(header => {
        let cellValue = '';
        if (header.value === 'id') {
          cellValue = index + 1; // Serial number
        } else if (header.value === 'date') {
          // Format date exactly like UI (MM/dd/yyyy)
          const dateValue = row[header.value];
          if (dateValue) {
            const date = new Date(dateValue);
            cellValue = date.toLocaleDateString('en-US'); // This gives MM/dd/yyyy format like UI
          }
        } else if (header.value === 'supplied' || header.value === 'amount') {
          // Handle 0 values properly for Quantity and Amount
          const value = row[header.value];
          cellValue = (value !== null && value !== undefined) ? value.toString() : '0';
        } else {
          cellValue = row[header.value] || '';
        }
        htmlTable += `<td>${cellValue}</td>`;
      });
      htmlTable += '</tr>';
    });
    htmlTable += '</tbody></table>';

    // Rest of the code remains the same...
    const excelContent = `
    <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel">
    <head>
      <meta charset="utf-8">
      <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Supplier Ledger</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->
    </head>
    <body>${htmlTable}</body>
    </html>
  `;

    // Download
    const blob = new Blob([excelContent], { type: 'application/vnd.ms-excel' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);
    link.setAttribute('download', `supplier_ledger_${new Date().toISOString().split('T')[0]}.xls`);
    link.style.visibility = 'hidden';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  const { responseData: supplierData } = useFetchCommon({
    api: `users?page=0&size=10&type=CUSTOMER&status=ACTIVE`,
    isDropDown: true,
    label: ['personalDetails', 'name'],
  })

  const handleChange = (name, value) => {
    setSearchResult(false)
    setUserSelectedData({ ...userSelectedData, [name]: value })
  }

  // const { responseData: supplierLedgerList } = useFetchCommon({
  //   api: `user/due/${userSelectedData.facility}?${stringifyRequestQuery(userSelectedData)}`,
  //   isEnabled: searchResult,
  //   label: ['personalDetails', 'name'],
  // })


  const { responseData: supplierLedgerList } = useFetchCommon({
    api: `user/due/${userSelectedData.facility}?${stringifyRequestQuery(userSelectedData)}`,
    isEnabled: searchResult,
    isDropDown: false, // ← Add this line
    // Remove the label line since you want raw data
  })


  console.log("supplierLedgerList is", supplierLedgerList)


  const [searchTerm, setSearchTerm] = useState('')

  // Add this filtered data logic
  const filteredSupplierData = supplierData.filter(supplier =>
    supplier.label.toLowerCase().includes(searchTerm.toLowerCase())
  )

  return (
    <KTCard>
      <div className={`grid grid-cols-4 gap-3 my-2 px-9 pt-5`}>
        <>
          {/* <div className=''>
            <label className='form-label fs-6 fw-bold'>Supplier</label>
            <select
              className='form-select form-select-solid'
              data-kt-select2='true'
              data-placeholder='Select option'
              data-allow-clear='true'
              onChange={(e) => handleChange('facility', e.target.value)}
              value={userSelectedData.facility || ''}
            >
              {[{ value: '', label: 'Select one' }, ...supplierData].map((eachOption, eachInd) => (
                <option key={eachInd + 1 + ''} value={eachOption.value}>
                  {eachOption.label}
                </option>
              ))}
            </select>
          </div> */}
          <div className=''>
            <label className='form-label fs-6 fw-bold' style={{ color: '#000000' }}>Plastic Keeper</label>
            <Select
              options={[{ value: '', label: 'Select one' }, ...supplierData]}
              value={supplierData.find(option => option.value === userSelectedData.facility) || null}
              onChange={(selectedOption) => handleChange('facility', selectedOption?.value || '')}
              placeholder="Select Plastic Keeper"
              isSearchable={true}
              isClearable={true}
              styles={{
                control: (provided) => ({
                  ...provided,
                  height: '38px',
                  minHeight: '38px',
                  border: '1px solid #e4e6ef',
                  borderRadius: '0.475rem',
                  fontSize: '14px',
                  boxShadow: 'none',
                  '&:hover': {
                    borderColor: '#b5b5c3'
                  }
                })
              }}
            />
          </div>
          <div className='d-flex flex-column'>
            <label className='form-label fs-6 fw-bold' style={{ color: '#000000' }}>Start date</label>
            <DatePicker
              customInput={
                <input
                  style={{
                    backgroundColor: '#ffffff',
                    border: '1px solid #e4e6ef',
                    color: '#000000',
                    borderRadius: '0.475rem',
                    height: '38px',
                    padding: '0 12px',
                    fontSize: '14px',
                    width: '100%',
                    outline: 'none'
                  }}
                />
              }
              placeholderText={`Select start date`}
              className='w-100'
              maxDate={new Date()}
              selected={userSelectedData.start_date || null}
              onChange={(date) => handleChange('start_date', new Date(date))}
            />
          </div>
          <div className='d-flex flex-column'>
            <label className='form-label fs-6 fw-bold' style={{ color: '#000000' }}>End date</label>
            <DatePicker
              customInput={
                <input
                  style={{
                    backgroundColor: '#ffffff',
                    border: '1px solid #e4e6ef',
                    color: '#000000',
                    borderRadius: '0.475rem',
                    height: '38px',
                    padding: '0 12px',
                    fontSize: '14px',
                    width: '100%',
                    outline: 'none'
                  }}
                />
              }
              placeholderText={`Select end date`}
              className='w-100'
              maxDate={new Date()}
              selected={userSelectedData.end_date || null}
              onChange={(date) => handleChange('end_date', new Date(date))}
            />
          </div>
          <div
            className='d-flex align-items-end'
            style={{
              gap: '10px',
              paddingBottom: '2px'
            }}
          >
            <button
              type='button'
              onClick={() => setSearchResult(true)}
              className='btn btn-primary fw-bold px-6'
              style={{ height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              data-kt-menu-dismiss='true'
              data-kt-user-table-filter='filter'
            >
              Apply
            </button>
            <button
              type='button'
              style={{ backgroundColor: '#000000', color: '#ffffff', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              onClick={downloadExcel}
              className='btn fw-bold px-6 btn-dark'
              data-kt-menu-dismiss='true'
              data-kt-user-table-filter='filter'
              disabled={!supplierLedgerList || supplierLedgerList.length === 0 || !searchResult}
            >
              Download
            </button>
          </div>
        </>
      </div>

      <div ref={certificateRef}>
        {/* Metrics Cards */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '20px', padding: '20px 30px' }}>

          {/* Card 1 */}
          <div style={{ backgroundColor: '#ffffff', borderRadius: '12px', padding: '16px', display: 'flex', alignItems: 'center', gap: '16px', border: '1px solid #F0F1F3', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.02)' }}>
            <div style={{ backgroundColor: '#FFE500', width: '56px', height: '56px', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0 }}>
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 7.5L12 3L21 7.5V16.5L12 21L3 16.5V7.5Z"
                  stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M3 7.5L12 12L21 7.5"
                  stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 12V21"
                  stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 5L16 9"
                  stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <div>
              <div style={{ color: '#000000', fontSize: '12px', fontWeight: '600', marginBottom: '6px' }}>Material supplied</div>
              <div style={{ color: '#000000', fontSize: '22px', fontWeight: '700', lineHeight: '1' }}> {(supplierLedgerList?.[0]?.totalSupplied ?? 0).toLocaleString("en", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}</div>
              <div style={{ color: '#7E8299', fontSize: '12px', marginTop: '6px' }}>All time</div>
            </div>
          </div>

          {/* Card 2 */}
          <div style={{ backgroundColor: '#ffffff', borderRadius: '12px', padding: '16px', display: 'flex', alignItems: 'center', gap: '16px', border: '1px solid #F0F1F3', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.02)' }}>
            <div style={{ backgroundColor: '#000000', width: '56px', height: '56px', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0 }}>
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="9"
                  stroke="#ffffff" strokeWidth="2" />
                <path d="M14.5 8.5C14 7.8 13.2 7.5 12.2 7.5C10.9 7.5 10 8.2 10 9.2C10 10.2 10.8 10.7 12.2 11.1L13 11.3C14.4 11.7 15.2 12.2 15.2 13.3C15.2 14.5 14.1 15.3 12.6 15.3C11.4 15.3 10.3 14.8 9.7 14"
                  stroke="#ffffff" strokeWidth="2" strokeLinecap="round" />
                <path d="M12 6V18"
                  stroke="#ffffff" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </div>
            <div>
              <div style={{ color: '#000000', fontSize: '12px', fontWeight: '600', marginBottom: '6px' }}>Total value</div>
              <div style={{ color: '#000000', fontSize: '22px', fontWeight: '700', lineHeight: '1' }}>{(supplierLedgerList?.[0]?.totalDue ?? 0).toLocaleString("en", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}</div>
              <div style={{ color: '#7E8299', fontSize: '12px', marginTop: '6px' }}>All time</div>
            </div>
          </div>

          {/* Card 3 */}
          <div style={{ backgroundColor: '#ffffff', borderRadius: '12px', padding: '16px', display: 'flex', alignItems: 'center', gap: '16px', border: '1px solid #F0F1F3', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.02)' }}>
            <div style={{ backgroundColor: '#FFE500', width: '56px', height: '56px', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0 }}>
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="5" width="18" height="14" rx="2"
                  stroke="#000000" strokeWidth="2" />
                <path d="M3 9H21"
                  stroke="#000000" strokeWidth="2" strokeLinecap="round" />
                <path d="M7 14H11"
                  stroke="#000000" strokeWidth="2" strokeLinecap="round" />
                <path d="M15 14L16.5 15.5L19 12.5"
                  stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <div>
              <div style={{ color: '#000000', fontSize: '12px', fontWeight: '600', marginBottom: '6px' }}>Total payment</div>
              <div style={{ color: '#000000', fontSize: '22px', fontWeight: '700', lineHeight: '1' }}>  {(supplierLedgerList?.[0]?.totalPaid ?? 0).toLocaleString("en", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}</div>
              <div style={{ color: '#7E8299', fontSize: '12px', marginTop: '6px' }}>All time</div>
            </div>
          </div>

          {/* Card 4 */}
          <div style={{ backgroundColor: '#ffffff', borderRadius: '12px', padding: '16px', display: 'flex', alignItems: 'center', gap: '16px', border: '1px solid #F0F1F3', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.02)' }}>
            <div style={{ backgroundColor: '#000000', width: '56px', height: '56px', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0 }}>
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 6.5C4 5.67 4.67 5 5.5 5H19C19.55 5 20 5.45 20 6V18C20 18.55 19.55 19 19 19H5.5C4.67 19 4 18.33 4 17.5V6.5Z"
                  stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M4 8H20"
                  stroke="#ffffff" strokeWidth="2" strokeLinecap="round" />
                <path d="M15 14H20"
                  stroke="#ffffff" strokeWidth="2" strokeLinecap="round" />
                <circle cx="15" cy="14" r="0.8" fill="#ffffff" />
              </svg>
            </div>
            <div>
              <div style={{ color: '#000000', fontSize: '12px', fontWeight: '600', marginBottom: '6px' }}>Closing balance</div>
              <div style={{ color: '#000000', fontSize: '22px', fontWeight: '700', lineHeight: '1' }}>  {(supplierLedgerList?.[0]?.totalBalance ?? 0).toLocaleString("en", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}</div>
              <div style={{ color: '#7E8299', fontSize: '12px', marginTop: '6px' }}>All time</div>
            </div>
          </div>

        </div>

        <UsersTable
          // mockedData={supplierLedgerList.transactions || []}
          mockedData={supplierLedgerList?.[0]?.transactions || []}
          columnProps={roleColumns(false)}
        />
      </div>


      {/* <div className='row g-3 g-xl-8 mt-2'>
        <div className='col-xl-3'>
          <StatisticsWidget6
            className='card-xl-stretch mb-xl-8'
            color='warning'
            title=''
            description='Material Supplied'
            progress={supplierLedgerList.totalSupplied ?? ''}
          />
        </div>
        <div className='col-xl-3'>
          <StatisticsWidget6
            className='card-xl-stretch mb-xl-8'
            color='primary'
            title=''
            description='Total Value'
            progress={supplierLedgerList.totalDue ?? ''}
          />
        </div>

        <div className='col-xl-3'>
          <StatisticsWidget6
            className='card-xl-stretch mb-xl-8'
            color='primary'
            title=''
            description='Closing Balance'
            progress={supplierLedgerList.totalBalance ?? ''}
          />
        </div>
        <div className='col-xl-3'>
          <StatisticsWidget6
            className='card-xl-stretch mb-xl-8'
            color='primary'
            title=''
            description='Total Payment'
            progress={supplierLedgerList.totalPaid ?? ''}
          />
        </div>
      </div> */}
    </KTCard>
  )
}

const SupplyLedgerReportWrapper = () => (
  <QueryRequestProvider initialValue={{ enabled: false }}>
    <QueryResponseProvider>
      <ListViewProvider>
        <QualityList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export { SupplyLedgerReportWrapper }
